"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var ProposalFinishedIcon_1 = __importDefault(require("../../../Icons/Notifications/ProposalFinishedIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "The votes are in! Find out the outcome of the voting on",
            ' ',
            react_1.default.createElement("a", { className: "dcl notification-link", href: link },
                ' ',
                "your proposal"),
            ".")); },
        title: 'Voting ended on your proposal'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Ya estan los votos! Descubre el resultado de la votacion en",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "tu propuesta"),
            ".")); },
        title: 'La votacion finalizo en tu propuesta'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u6295\u7968\u7ED3\u679C\u51FA\u6765\u4E86\uFF01",
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u4E86\u89E3\u60A8\u63D0\u6848\u7684\u6295\u7968\u7ED3\u679C"),
            ".")); },
        title: '您的提案投票结束'
    }
};
var GovernanceAuthoredProposalFinishedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(ProposalFinishedIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" },
            i18N[locale].title,
            ' ',
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceAuthoredProposalFinishedNotification;
